// @flow
/**
 * Texto plano de un cuerpo en HTML.
 *
 * Vive en un módulo hoja, sin imports, porque lo usan tanto `articles.js` como el modelo de
 * listados (`models.js`): si el modelo importara `articles.js` arrastraría consigo los componentes
 * de tabular que este importa a todo el store.
 */
// Cierres de bloque que deben convertirse en un espacio antes de quitar el resto de etiquetas.
// Sin esto, el replace genérico pega el final de un bloque con el principio del siguiente y salen
// palabras fundidas: la firma del cuerpo se une al primer párrafo y se lee
// "Paula SampedroAnalista de Renta FijaAgosto ha sido un mes de presión...".
const BLOCK_BOUNDARIES_REGEX =
  /<\/(?:p|div|h[1-6]|li|ul|ol|dl|dd|dt|blockquote|figure|figcaption|table|thead|tbody|tr|td|th|section|article|header|footer|aside|pre|address)\s*>|<(?:br|hr)\s*\/?>/gi;

/**
 * Convierte el HTML del cuerpo de un artículo en texto plano legible, sin truncar.
 *
 * @param html Cuerpo del artículo en HTML
 */
export const getArticlePlainText = (html: string): string => {
  if (!html) return '';

  // eliminar los pies de foto de las imágenes en figcaption
  const previewWithoutCaptions = html.replace(/<figcaption>[\s\S]*?<\/figcaption>/g, '');

  // parse special character &amp; to &
  const previewParsed = previewWithoutCaptions.replace(/&amp;/g, '&');
  // remove every string that starts with ARTICLE-GROUP or ARTICLE-MODULE
  const previewWithoutModules = previewParsed.replace(/ARTICLE-(GROUP|MODULE)[^<]*<\/[^>]*>/g, '');

  // separar bloques ANTES de quitar etiquetas, para no fundir la última palabra con la primera
  const previewWithBoundaries = previewWithoutModules.replace(BLOCK_BOUNDARIES_REGEX, ' ');

  const preview = previewWithBoundaries.replace(/<[^>]*>?/g, '');

  // sustituir caracteres especiales
  const previewClean = preview
    .replace(/&nbsp;/g, ' ')
    .replace(/&aacute;/g, 'á')
    .replace(/&eacute;/g, 'é')
    .replace(/&iacute;/g, 'í')
    .replace(/&oacute;/g, 'ó')
    .replace(/&uacute;/g, 'ú')
    .replace(/&ntilde;/g, 'ñ')
    .replace(/&Aacute;/g, 'Á')
    .replace(/&Eacute;/g, 'É')
    .replace(/&Iacute;/g, 'Í')
    .replace(/&Oacute;/g, 'Ó')
    .replace(/&Uacute;/g, 'Ú')
    .replace(/&Ntilde;/g, 'Ñ');

  // los separadores de bloque dejan espacios de más: colapsarlos para no truncar contando huecos
  return previewClean.replace(/\s+/g, ' ').trim();
};
